import { ContactDetail } from '@/lib/api';

export function getDateGroup(dateStr: string): string {
  const date = new Date(dateStr);
  const now = new Date();
  const thisMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  const threeMonthsAgo = new Date(now.getFullYear(), now.getMonth() - 3, 1);

  if (date >= thisMonth) return 'This Month';
  if (date >= lastMonth) return 'Last Month';
  if (date >= threeMonthsAgo) return 'Last 3 Months';
  return 'Earlier';
}

export function groupContactsByDate(contacts: ContactDetail[]): Map<string, ContactDetail[]> {
  const groups = new Map<string, ContactDetail[]>();
  const order = ['This Month', 'Last Month', 'Last 3 Months', 'Earlier'];

  for (const label of order) {
    groups.set(label, []);
  }

  for (const contact of contacts) {
    const group = getDateGroup(contact.gatheredAt);
    groups.get(group)!.push(contact);
  }

  // Remove empty groups
  for (const [key, value] of groups) {
    if (value.length === 0) groups.delete(key);
  }

  return groups;
}

export function formatDate(dateStr: string): string {
  return new Date(dateStr).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}
